export default {
  two_factor_authentication: {
    resend_token_time: process.env.REACT_APP_RESEND_TOKEN_IN_MS,
  },
};
